module.exports = __webpack_public_path__ + "img/14.45ab39cf.png";